import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TetraResourcesComponent from '../components/tetraResourcesComponent'; 
import { fetchTetraResourcesList}from '../action/tetraResourcesAction'; 

class TetraResourcesContainer extends Component {
    constructor(props) {
        super(props);
        
        
    }

    componentDidMount() {
       
           this.props.actions.fetchTetraResourcesList( 
                   this.props.dispatch
               )
           
    }
    getTetraResourcesList = () =>{
        this.props.actions.fetchTetraResourcesList(
            this.props.dispatch
        )
    }
   
    
    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row"> 
                            <TetraResourcesComponent                                 
                                 getTetraResources={this.props.updateTetraResources}
                                getTetraResourcesList = {this.getTetraResourcesList}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            fetchTetraResourcesList
        }, dispatch)
    };
};

function mapStateToProps({ TetraResourcesReducer }) { 
    return {  
        updateTetraResources: {
            isLoading: TetraResourcesReducer.isLoading,
            statusCode: TetraResourcesReducer.statusCode,
            errorMessage: TetraResourcesReducer.errorMessage,
            messageLabel: TetraResourcesReducer.messageLabel,
            tetraResourceList : TetraResourcesReducer.tetraResourceList
        } 
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TetraResourcesContainer))